import SignIn from "../pages/auth/SignIn";
import MobileAuth from "../pages/auth/MobileAuth";
import SignUp from "../pages/auth/SignUp";
import Disclaimer from "../pages/misc/Disclaimer";
import { useSearchParams } from "react-router-dom";
// import MobileChange from "../pages/misc/MobileChange";
import Policy from "../pages/misc/Policy";
import TAC from "../pages/misc/TAC";
import ForgotPassword from "../pages/user/ForgotPassword";
import ResetPassword from "../pages/user/ResetPassword";

function SignInOrMobileAuth() {
  const [searchParams] = useSearchParams();
  return searchParams.get("token") ? <MobileAuth /> : <SignIn />;
}

export const publicRoutes = [
  { path: "/", element: <SignInOrMobileAuth /> },
  { path: "/mobile-auth", element: <MobileAuth /> },
  { path: "/signup", element: <SignUp /> },
  { path: "/forgot", element: <ForgotPassword /> },
  { path: "/user/reset-password/:id", element: <ResetPassword /> },
  { path: "/disclaimer", element: <Disclaimer /> },
  { path: "/terms", element: <TAC /> },
  { path: "/policy", element: <Policy /> },
  // { path: "/mobile/:id", element: <MobileChange /> },
];
